import { get } from 'lodash';

export const createBaseUserActionEvent = ({ targetLocale, sourceInfo: { gig, user, ...page } }) => ({
    user_id: get(user, 'id'),
    'Gig Id': get(gig, 'id'),
    Page: get(page, 'name'),
    Component: get(page, 'component.name'),
    'User Locale': targetLocale,
});
